import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const defaultBreakVars: MotifComponentProps<MotifComponent.BREAK> = {
  '--break-total-desktop-height': '96px',
  '--break-half-desktop-height': '48px',
  '--break-total-mobile-height': '32px',
  '--break-half-mobile-height': '16px',
  '--break-shadow-light-color': m('--primary-v100'),
  '--break-shadow-dark-color': m('--neutral-v700'),
};
